// src/locales/en/sidebar.js
export const sidebar = {
    collapseTooltip: "Collapse sidebar",
    expandTooltip: "Expand sidebar",
    groupOverview: "Overview",
    groupSales: "Sales & Orders",
    groupLogistics: "Logistics",
    groupCatalog: "Catalog & Inventory",
    groupFinance: "Finance & Reports",
    groupPeople: "People",
    groupSystem: "System",
    allOrders: "All Online Orders",
    createOrder: "Create Online Order",
    storePickupOrders: "Store Pickup Orders",
    bulkOrderCreate: "Upload Leads",
    orderAssignment: "Order Assignment",
    callCenter: "Call Center",
    assignmentRules: "Assignment Rules",
    manualAssignment: "Manual Assignment",
    myWorkQueue: "My Work Queue",
    packingBatches: "Packing Batches",
    paymentVerification: "Payment Verification",
    dispatchSingleOrder: "Dispatch Single Order",
    courierUploadFormat: "Courier Upload Format",
    courierInvoices: "Courier Invoices",
    allInvoices: "All Invoices",
    createInvoice: "Create Invoice",
    returnBatches: "Return Batches",
    allReturnBatches: "All Return Batches",
    processReturns: "Process Returns",
    deliveryFollowUp: "Delivery Follow-up",
    settlementBatches: "Settlement Batches",
    returns: "Returns",
    allProducts: "All Products",
    addProduct: "Add Product",
    categories: "Categories",
    attributes: "Attributes",
    brands: "Brands",
    tags: "Tags",
    stockOverview: "Stock Overview",
    purchaseOrders: "Purchase Orders",
    stockAdjustments: "Stock Adjustments",
    stockTransfers: "Warehouse Transfers",
    warehouses: "Warehouses",
    suppliers: "Suppliers",
    goodsReceivedNotes: "Goods Received Notes",
    returnsToVendor: "Returns to Vendor",
    debitNotes: "Debit Notes",
    payables: "Payables",
    expenses: "Expenses",
    leadAutomation: "Lead Automation",
    messageCenter: "Message Center",
    messageCenterShifts: "Shifts",
    messageCenterShiftTypes: "Shift Types",
    messageCenterCommission: "Commission",
    messageCenterStaffCommission: "Staff Commission",
    messageCenterShiftLeaderCommission: "Shift Leader Commission",
    callCenterShifts: "Shifts",
    callCenterCommission: "Cross-Selling Commission",
    callCenterStaffCommission: "Staff Commission",
    allUsers: "All Users",
    addUser: "Add User",
    userRoles: "User Roles",
    createRole: "Create Role",
    allShops: "All Shops",
    addShop: "Add Shop",
    salesReports: "Sales Reports",
    productWiseSales: "Product Wise Sales",
    productWiseReturns: "Product Wise Returns",
    profitAndLoss: "Profit & Loss",
    courierPerformance: "Courier Performance",
    messageCenterSummary: "Message Center Summary",
    callCenterSummary: "Call Center Summary",
    inventoryReports: "Inventory Reports",
    analytics: "Analytics",
    courierManagement: "Courier Management",
    courierAssignmentRules: "Courier Assignment Rules",
    commissionConfig: "Commission Config",
    commissionReport: "Commission Report",
    callcenterPerformance: "Callcenter Performance",
    phoneBlacklist: "Phone Blacklist",

    woocommerceSync: "WooCommerce Order Sync",
    openTerminal: "Open Terminal",
    posOrders: "POS Orders",
    posCustomers: "POS Customers",
    posSessions: "Cashier Sessions",
    posSettings: "POS Settings",
    posPaymentMethods: "Payment Methods",
    offlineSales: "Offline Sales",
    offlineSalesOrders: "Offline Sales Orders",
    createOfflineSalesOrder: "Create Offline Sales Order",
    offlineSalesCustomers: "Customers",
    offlineSalesSessions: "Cashier Sessions",
    offlineSalesReceivables: "Receivables",
    offlineSalesCustomerPayments: "Customer Payments",
    offlineSalesCheques: "Cheques",
    offlineSalesQuotations: "Quotations",
    offlineSalesDeliveryNotes: "Delivery Notes",
    offlineSalesReturnNotes: "Return Notes",
    offlineSalesCreditNotes: "Credit Notes",
    offlineSalesSettings: "Settings",
    offlineSalesPaymentMethods: "Payment Methods",
    offlineSalesPacking: "Courier Packing",
    version: "v1.0.0"
}